<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items="events"
        :search="search"
        class="elevation-0"
        item-key="eventid"
        :footer-props="footerProps" no-data-text="пусто" no-results-text="ничего не найдено"
        :items-per-page.sync="itemsPerPage"
        dense flat
      >
        <template v-slot:item.cts="{ item }">
          {{ dateFormat(item.cts) }}
        </template>
        <template v-slot:item.originalts="{ item }">
          {{ dateFormat(item.originalts) }}
        </template>
        <template v-slot:item.direction="{ item }">
          <v-btn text small class="no-text-transform body-2" color="primary"
            @click="$emit('search', item.direction)"
          >{{ item.direction }}</v-btn>
        </template>
        <template v-slot:item.controllername="{ item }">
          <v-btn text small class="no-text-transform body-2" color="primary"
            @click="$emit('search', item.controllername)"
          >{{ item.controllername }}</v-btn>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ListEvents',
  props: [ 'events', 'sort-by', 'search' ],
  data: () => ({
    headers: [
      { text: 'id', value: 'eventid', width: '100' },
      { text: 'место', width: '300', value: 'controllername', },
      { text: 'карта', width: '140', value: 'cardid', },
      { text: 'код', width: '140', value: 'code', },
      { text: 'направление', value: 'direction', width: '140' },
      { text: 'оригинальная дата', width: '240', value: 'originalts', },
      { text: 'дата регистрации на сервере', width: '240', value: 'cts', },
    ],
    footerProps: {
      itemsPerPageText: 'показывать записей',
      itemsPerPageOptions: [ 15, 100, { text:'Все', value:-1 } ]
    },
    itemsPerPage: 15
  }),
  methods: {
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    rubles (kops) {
      return (parseFloat(kops) / 100).toFixed(2)
    },
  }
}
</script>

<style lang="css">
</style>
